import Vue from 'vue'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'
import VueGtag from 'vue-gtag'
import BaseArticlePage from '../views/BaseArticlePage'
import Top from '../views/Top'
import BaseCategoryPage from '../views/BaseCategoryPage'
import BaseDesignPaperSamplePage from '../views/BaseDesignPaperSamplePage'
import ColorioNengaVersionUp from '../views/ColorioNengaVersionUp'
import EndPremiumNengaPage from '../views/EndPremiumNengaPage'
import ClientHelper from '../common/client.helper'
import DesignPaperLandingPage from '../views/DesignPaperLandingPage'
import CreatePlusTop from '../views/CreatePlusTop'
import CreatePlusGuide from '../views/CreatePlusGuide'
import CreatePlusBaseTemplateListPage from '../views/CreatePlusBaseTemplateListPage'
import CreatePlusBaseTemplatePage from '../views/CreatePlusBaseTemplatePage'
import CreatePlusAppTop from '../views/CreatePlusAppTop'
import CreatePlusAppTemplateListPage from '../views/CreatePlusAppTemplateListPage'
import CreatePlusAppTemplatePage from '../views/CreatePlusAppTemplatePage'
import store from '@/store/index';

Vue.use(VueRouter)
Vue.use(Meta)

const routes = [
  {
    path: '/',
    redirect: () => {
      return { path: ClientHelper.checkLanguageCode(ClientHelper.getUrlParam('LG2') || ClientHelper.getLanguage()) + '/' }
    }
  },
  {
    path: '/articles/:id',
    redirect: () => {
      return { path: ClientHelper.checkLanguageCode(ClientHelper.getUrlParam('LG2') || ClientHelper.getLanguage()) + '/articles/:id' }
    }
  },
  {
    path: '/categories/:categoryUrl',
    redirect: () => {
      return { path: ClientHelper.checkLanguageCode(ClientHelper.getUrlParam('LG2') || ClientHelper.getLanguage()) + '/categories/:categoryUrl' }
    }
  },
  {
    path: '/designpaper/:designId',
    redirect: () => {
      return { path: ClientHelper.checkLanguageCode(ClientHelper.getUrlParam('LG2') || ClientHelper.getLanguage()) + '/designpaper/:designId' }
    }
  },
  {
    path: '/colorio-nenga/creators',
    redirect: () => {
      return { path: ClientHelper.checkLanguageCode(ClientHelper.getUrlParam('LG2') || ClientHelper.getLanguage()) + '/colorio-nenga/creators' }
    }
  },
  {
    path: '/colorio-nenga/premium',
    redirect: () => {
      return { path: ClientHelper.checkLanguageCode(ClientHelper.getUrlParam('LG2') || ClientHelper.getLanguage()) + '/colorio-nenga/premium' }
    }
  },
  {
    path: '/colorio-nenga/sanrio2023',
    redirect: () => {
      return { path: ClientHelper.checkLanguageCode(ClientHelper.getUrlParam('LG2') || ClientHelper.getLanguage()) + '/colorio-nenga/sanrio2023' }
    }
  },
  {
    path: '/colorio-nenga/peterrabbit2023',
    redirect: () => {
      return { path: ClientHelper.checkLanguageCode(ClientHelper.getUrlParam('LG2') || ClientHelper.getLanguage()) + '/colorio-nenga/peterrabbit2023' }
    }
  },
  {
    path: '/lp/designpaper',
    redirect: () => {
      return { path: ClientHelper.checkLanguageCode(ClientHelper.getUrlParam('LG2') || ClientHelper.getLanguage()) + '/lp/designpaper' }
    }
  },
  {
    path: '/createplus',
    redirect: () => {
      return { path: '/createplus/' + ClientHelper.checkLanguageCode(ClientHelper.getUrlParam('LG2') || ClientHelper.getLanguage()) + '/' }
    }
  },
  {
    path: '/createplus/app/',
    redirect: () => {
      return { path: '/createplus/' + ClientHelper.checkLanguageCode(ClientHelper.getUrlParam('LG2') || ClientHelper.getLanguage()) + '/app/' }
    }
  },
  {
    path: '/createplus/templates/guide',
    redirect: () => {
      return { path: '/createplus/' + ClientHelper.checkLanguageCode(ClientHelper.getUrlParam('LG2') || ClientHelper.getLanguage()) + '/templates/guide' }
    }
  },
  {
    path: '/createplus/templates/:categoryid/:subcategoryid',
    redirect: () => {
      return { path: '/createplus/' + ClientHelper.checkLanguageCode(ClientHelper.getUrlParam('LG2') || ClientHelper.getLanguage()) + '/templates/:categoryid/:subcategoryid' }
    }
  },
  {
    path: '/createplus/templates/:categoryid/:subcategoryid/:templateid',
    redirect: () => {
      return { path: '/createplus/' + ClientHelper.checkLanguageCode(ClientHelper.getUrlParam('LG2') || ClientHelper.getLanguage()) + '/templates/:categoryid/:subcategoryid/:templateid' }
    }
  },
  {
    path: '/colorio-nenga/endpremium',
    redirect: () => {
      return { path: ClientHelper.checkLanguageCode(ClientHelper.getUrlParam('LG2') || ClientHelper.getLanguage()) + '/colorio-nenga/endpremium' }
    }
  },
 
  {
    path: '/:lang/colorio-nenga/sanrio2023',
    component: EndPremiumNengaPage
  },
  {
    path: '/:lang/colorio-nenga/peterrabbit2023',
    component: EndPremiumNengaPage
  },
  {
    path: '/:lang/articles/:id',
    component: BaseArticlePage,
    props: true
  },
  {
    path: '/:lang/categories/:categoryUrl',
    component: BaseCategoryPage,
    props: true
  },
  {
    path: '/:lang/designpaper/:designId',
    component: BaseDesignPaperSamplePage,
    props: true
  },
  {
    path: '/:lang/colorio-nenga/creators',
    component: ColorioNengaVersionUp
  },
  {
    path: '/:lang/colorio-nenga/premium',
    component: ColorioNengaVersionUp
  },
  {
    path: '/:lang/lp/designpaper',
    component: DesignPaperLandingPage
  },
  {
    path: '/createplus/:lang',
    component: CreatePlusTop
  },
  {
    path: '/createplus/:lang/app',
    component: CreatePlusAppTop
  },
  {
    path: '/createplus/:lang/app/templates/:categoryid/:subcategoryid',
    component: CreatePlusAppTemplateListPage,
    props: true
  },
  {
    path: '/createplus/:lang/app/templates/:categoryid/:subcategoryid/:templateid',
    component: CreatePlusAppTemplatePage,
    props: true
  },
  {
    path: '/createplus/:lang/templates/guide',
    component: CreatePlusGuide,
    props: true
  },
  {
    path: '/createplus/:lang/templates/:categoryid/:subcategoryid',
    component: CreatePlusBaseTemplateListPage,
    props: true
  },
  {
    path: '/createplus/:lang/templates/:categoryid/:subcategoryid/:templateid',
    component: CreatePlusBaseTemplatePage,
    props: true
  },
  {
    path: '/:lang/colorio-nenga/endpremium',
    component: EndPremiumNengaPage
  },
  {
    path: '/:lang',
    component: Top,
    props: true
  }
]

const router = new VueRouter({
  routes,
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(savedPosition)
        }, 500)
      })
    } else if(to.hash) {
      return {
        selector: to.hash
      }
    }else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  store.commit('setShowHumbugerMenu', false)
  store.commit('setShowLangModal', false)
  next()
})

Vue.use(VueGtag, {
  config: {id: 'G-6MMZJTDX6P'}
}, router);

export default router
